import reduce from 'lodash/reduce'

import { R } from '@utils/currency'

/*
 * Sum the values in the 'current' budget
 * @param { Object } budgetValues - An object containing the values
 *  for both the current and retirement budget values
 *  Example:
 *    {
 *      Electric: [1000, 2000],
 *      Internet: [1000, 3000]
 *    }
 *  @return { number } total - The total value of the current budget
 */
export const currentBudgetTotal = (budgetValues) =>
  reduce(budgetValues, sumBudgetAtIndex(0), 0)

/*
 * Sum the values in the 'retirement' budget
 * @param { Object } budgetValues - An object containing the values
 *  for both the current and retirement budget values
 *  Example:
 *    {
 *      Electric: [1000, 2000],
 *      Internet: [1000, 3000]
 *    }
 *  @return { number } total - The total value of the retirement budget
 */
export const retirementBudgetTotal = (budgetValues) =>
  reduce(budgetValues, sumBudgetAtIndex(1), 0)

/*
 * Sum the values in the 'current' budget for a given category
 * Values for the 'current' budget is stored at index 0 of the values
 * array and so values at index [0] is summed over.
 * @param { string } budgetCategory - budget category to sum for
 * @param { Object } budgetCategories - all available budgetCategories
 *  and their items
 * @param { Object } values - current values of the detailed budget
 * @return { number } - the total value
 */
export const totalCurrentForBudgetCategory = (budgetCategory, budgetCategories, values) => {
  const itemsForCategory = budgetCategories[budgetCategory]
  const total = itemsForCategory.reduce((accumulator, item) =>
    accumulator + R(values[item] && values[item][0]).value
    , 0)
  return R(total).format()
}

/*
 * Sum the values in the 'retirement' budget for a given category
 * Values for the 'retirement' budget is stored at index 1 of the values
 * array and so values at index [1] is summed over.
 * @param { string } budgetCategory - budget category to sum for
 * @param { Object } budgetCategories - all available budgetCategories
 *  and their items
 * @param { Object } values - current values of the detailed budget
 * @return { number } - the total value
 */
export const totalRetirementForBudgetCategory = (budgetCategory, budgetCategories, values) => {
  const itemsForCategory = budgetCategories[budgetCategory]
  const total = itemsForCategory.reduce((accumulator, item) =>
    accumulator + R(values[item] && values[item][1]).value
    , 0)
  return R(total).format()
}

const sumBudgetAtIndex = (budgetIndex) => (accumulator, value) =>
  accumulator + R(value[budgetIndex]).value
